import {GMI} from '../constants';

/**
 * @name setGmiState
 * @desc Action creator to set the passed value at the specified path in GMI State
 * @param {Array} path
 * @param {*} value
 * @returns {Object}
 * @memberof actions
 * @example
 * const path = ['app', 'nested_path'];
 * const value = false;
 * dispatch(setGmiState(path, value));
 */
export function setGmiState (path, value) {
  return {type: GMI.SET_GMI_STATE, path, value};
}

/**
 * @name deleteGmiState
 * @desc Action creator to delete any value at the specified path in GMI State
 * @param {Array} path
 * @returns {Object}
 * @memberof actions
 * @example
 * const path = ['app', 'nested_path'];
 * const value = false;
 * dispatch(setGmiState(path, value));
 */
export function deleteGmiState (path) {
  return {type: GMI.DELETE_GMI_STATE, path};
}
